import PrivateCloudName from './PrivateCloudName';
export default PrivateCloudName;
